import React from "react"

import WidgetHeaderButton from "./WidgetHeaderButton"
import RefreshButton from "./RefreshButton"

const ListWidgetHeader = ({
    isFetching,
    canAdd,
    iconComponent,
    listTitle,
    invalidate,
    onAdd,
    onFilterSelect
}) => (
    <h3 className="widget-header">
        {iconComponent}
        {listTitle}&nbsp;
        <div className="pull-right edge-pull-right-fix">
            <RefreshButton onClick={invalidate} />
            {onAdd && (
                <WidgetHeaderButton
                    onClick={onAdd}
                    disabled={!canAdd}
                    data-cy="headerAddButton"
                >
                    Add
                </WidgetHeaderButton>
            )}
            {onFilterSelect && (
                <WidgetHeaderButton
                    onClick={onFilterSelect}
                    data-cy="headerFilterButton"
                >
                    Filter
                </WidgetHeaderButton>
            )}
        </div>
    </h3>
)

export default ListWidgetHeader
